export default "__VITE_ASSET__DPkNqnCw__"